<div class="viewer-container">
    <a class="close-viewer" (click)="close.emit()">
        <i class="bi bi-x-circle close-button"></i>
    </a>
    <!-- PDF Viewer -->
    <embed [src]="url" class="pdf-viewer">
</div>